import { Breadcrumbs, Typography } from '@mui/material';
import styled from 'styled-components';

import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  && {
    flex-grow: 1;
    height: ${({ theme }) => theme.spacing(12)};
    display: flex;
    align-items: center;

    .MuiBreadcrumbs-li > a {
      color: ${({ theme }) => theme.palette.text.primary};
      text-decoration: none;
      ${({ theme }) => theme.typography.button1};
      transition: text-decoration 0.3s ease-in-out;

      &:hover {
        text-decoration: underline;
      }
    }

    .MuiBreadcrumbs-li > p {
      color: ${({ theme }) => theme.palette.text.secondary};
      ${({ theme }) => theme.typography.p7};
    }
  }
`;

export const Separator = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.text.primary};
    ${({ theme }) => theme.typography.p6};
  }
`;

export const Breadcrumb = styled(TruncatedText)`
  && {
    cursor: pointer;
  }
`;
